

export default {
  IS_AUTHENTICATED (state) {
    return state.token && state.user
  },

  GET_AUTHENTICATED_USER (state) {
      return state.user
  },

  GET_USER_id (state) {
    return state.user.id
  },

  GET_ROLE_USER (state) {
    return state.role
  },

  GET_NOTIFICATIONS (state) {
    return state.notifications
  }
}
